const action_types = require('./action_types');
const api = require('./language_api');
const Cookies = require('js-cookie');

var lang = Cookies.get('language');
var initialState;

if (lang === "en") {
  initialState = {
    content: api.getContent("en")
  };
} else if (lang === "kr") {
  initialState = {
    content: api.getContent("kr")
  };
} else {
  initialState = {
    content: api.getContent() // Loads default language content (en) as an initial state
  };
  Cookies.set('language', "en")
}


let reducer = function (state = initialState, action) {
  switch (action.type) {
    case action_types.SWITCH_LANGUAGE:
      return {
        content: api.getContent(action.language)
      };
    default:
      return state;
  }
};

module.exports = reducer;




// WEBPACK FOOTER //
// ./src/components/language/reducer.js